import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link, withRouter } from 'react-router-dom'
import ReactCountryFlag from 'react-country-flag'
import {
  Row,
  Col,
  Layout,
  Menu,
  Icon,
  Modal,
  Drawer,
  Button,
  Tooltip,
  Badge,
  Popover,
  Dropdown,
} from 'antd'
import NoticeIcon from 'ant-design-pro/lib/NoticeIcon'
import LangContext from 'modules/shared/context/langContext'
import * as authActions from 'modules/auth/actions'
import { removeUIState } from 'modules/ui/actions'
import SliderBar from './SliderBar'
import SafetyNotificationPopover from './SafetyNotificationPopover'
import styled from 'styled-components'
import { max } from 'date-fns'
import * as GPSServiceRequestsLib from '../../help/gps-service-requests/components/LIB'

//////////////////////////////////////////////////////////////
const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup
const { Header: H } = Layout
const StyledHearder = styled(H)`
  background: white;
  height: 45px;
`

const AUDIOS = [
  {
    name: 'alert',
    path: '/audio/alert/serious-strike.mp3',
  },
  {
    name: 'sos',
    path: '/audio/alert/sos.mp3',
  },
  {
    name: 'notification',
    path: '/audio/notification/slow-spring-board.mp3',
  },
]

class Header extends Component {
  static contextType = LangContext

  state = {
    collapsed: true,
    topMenuVisible: false,
    inputLng: '',
    visibleNotification: false,
    dataNoti: [],
    countAppoveRequestToUseVehicle: 0,
    countGPSServiceRequestsInstall: 0,
    countGPSServiceRequestsRepair: 0,
    countGPSServiceRequestsUninstall: 0,
    countGpsMonthlyUsage: 0,
    safetyNotiVisible: false,
    safetyNotiData: null,
    safetyNotiEvents: null,
    safetyUnreadCount: 0,
    safetyUnreadByType: null,
    safetyDetailEvents: {},
    safetyDetailHasMore: {},
    safetyDetailPage: {},
    safetyDetailLoading: {},
  }

  buildLogoutUrl = provider => {
    const redirectUri = encodeURIComponent(
      process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    )

    switch (provider) {
      case 'Azure':
        return `https://login.microsoftonline.com/5db8bf0e-8592-4ed0-82b2-a6d4d77933d4/oauth2/logout?post_logout_redirect_uri=${redirectUri}`
      case 'J2C':
        return `https://api-cpac.scg.com/auth/logout?redirect=${redirectUri}`
      default:
        return null
    }
  }

  logout = () => {
    const provider = localStorage.getItem('userAuthen')
    const url = this.buildLogoutUrl(provider)
    if (url) window.location.assign(url)
  }

  onRemoveCredentials = () => {
    if (typeof this.props.profile !== 'undefined') {
      this.updateUserHistoryLog()
    }

    this.logout()
    this.props.removeCredentials()
    this.props.removeUIState()

    localStorage.setItem('callbackUrl', this.props.location.pathname)
    localStorage.setItem('count-appove-request-vehicle', 0)
    localStorage.setItem('count-gps-service-requests-install', 0)
    localStorage.setItem('count-gps-service-requests-repair', 0)
    localStorage.setItem('count-gps-service-requests-uninstall', 0)
    localStorage.setItem('count-gps-monthly-usage', 0)
    localStorage.removeItem('notification-settings')
  }

  updateUserHistoryLog = () => {
    const { user_history_logon_id } = this.props.profile

    axios.post(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/updatelogonhistory`,
      { id: user_history_logon_id },
      { headers: { Authorization: `Bearer ${this.props.accessToken}` } },
    )
  }

  toggle = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }))
  }

  getNoticeData = (langContext, notices) => {
    if (notices.length === 0) return []

    const newNotices = notices.map(notice => {
      let newNotice = {
        ...notice,
        datetime: null,
        title: (
          <Link to={notice.path}>
            {
              langContext[notice.matching_name.charAt(0).toLowerCase()][
                notice.matching_name
              ]
            }
          </Link>
        ),
        avatar:
          'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png',
        extra: (
          <Button
            style={{ marginTop: '0px' }}
            size="small"
            icon="delete"
            onClick={() =>
              this.props.deleteFavoriteMenu(
                {
                  userId: this.props.profile.id,
                  favId: newNotice.id,
                  accessToken: this.props.accessToken,
                },
                () => false,
              )
            }
          />
        ),
      }

      // transform id to item key
      if (newNotice.id) {
        newNotice.key = newNotice.id
      }

      return newNotice
    })

    return newNotices
  }

  fetchData = async () => {
    try {
      const formData = new FormData()
      formData.append('user_id', this.props.profile.id)

      const res = await axios.post(
        `${process.env.REACT_APP_GO_API_ENDPOINT}/notification/get`,
        formData,
      )

      const { data, count } = res.data

      this.setState({ dataNoti: data, countNoti: count })
      localStorage.setItem('count-noti', count)
    } catch (error) {
      console.error('fetchData error:', error)
    }
  }

  fetchCountAppoveRequestToUseVehicle = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/vehicle-share-available-account/notification`,
        {
          vehicleVisibility: this.props.profile.vehicle_visibility,
        },
        {
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
        },
      )

      if (res.data.status === 200) {
        const count = res.data.data

        this.setState({ countAppoveRequestToUseVehicle: count })
        localStorage.setItem('count-appove-request-vehicle', count)
      } else {
        console.warn('API ERROR:', res.data)
      }
    } catch (error) {
      console.error('fetchCountAppoveRequestToUseVehicle error:', error)
    }
  }

  fetchCountGPSServiceRequestsInstall = async () => {
    let role = await GPSServiceRequestsLib.handleCheckRole(
      this.props.profile.permissions,
      'gpsInstallation',
      this.props.profile.user_type,
      this.props.profile.is_gps_vendor,
    )

    await fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/gps-service-requests/gps-install-notification`,
      {
        method: 'POST',
        body: JSON.stringify({
          vehicle_visibility: this.props.profile.vehicle_visibility,
          role,
          company_id: this.props.profile.company_id,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.accessToken}`,
        },
      },
    )
      .then(response => response.json())
      .then(data => {
        this.setState({
          countGPSServiceRequestsInstall: data.data || 0,
        })
        localStorage.setItem(
          'count-gps-service-requests-install',
          data.data || 0,
        )
      })
  }

  fetchCountGPSServiceRequestsRepair = async () => {
    let role = await GPSServiceRequestsLib.handleCheckRole(
      this.props.profile.permissions,
      'gpsRepair',
      this.props.profile.user_type,
      this.props.profile.is_gps_vendor,
    )

    await fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/gps-service-requests/gps-repair-notification`,
      {
        method: 'POST',
        body: JSON.stringify({
          vehicle_visibility: this.props.profile.vehicle_visibility,
          role,
          company_id: this.props.profile.company_id,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.accessToken}`,
        },
      },
    )
      .then(response => response.json())
      .then(data => {
        this.setState({
          countGPSServiceRequestsRepair: data.data || 0,
        })
        localStorage.setItem(
          'count-gps-service-requests-repair',
          data.data || 0,
        )
      })
  }

  fetchCountGPSServiceRequestsUninstall = async () => {
    let role = await GPSServiceRequestsLib.handleCheckRole(
      this.props.profile.permissions,
      'gpsUninstallation',
      this.props.profile.user_type,
      this.props.profile.is_gps_vendor,
    )

    await fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/gps-service-requests/gps-uninstall-notification`,
      {
        method: 'POST',
        body: JSON.stringify({
          vehicle_visibility: this.props.profile.vehicle_visibility,
          role,
          company_id: this.props.profile.company_id,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.accessToken}`,
        },
      },
    )
      .then(response => response.json())
      .then(data => {
        this.setState({
          countGPSServiceRequestsUninstall: data.data || 0,
        })
        localStorage.setItem(
          'count-gps-service-requests-uninstall',
          data.data || 0,
        )
      })
  }

  // ประสิทธิภาพอุปกรณ์รายเดือน: vendor = ตัววัดที่ยัง declare ได้ · ผู้ตรวจ = declare ที่รอตรวจ
  fetchCountGpsMonthlyUsage = async () => {
    const permission = (this.props.profile.permissions || []).find(
      item => item.matching_name === 'gpsMonthlyUsage',
    )
    if (!permission || Number(permission.can_view) !== 1) {
      return
    }

    await fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/gps-usage/notification-count`,
      {
        method: 'POST',
        body: JSON.stringify({
          vehicle_visibility: this.props.profile.vehicle_visibility,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.accessToken}`,
        },
      },
    )
      .then(response => response.json())
      .then(data => {
        this.setState({
          countGpsMonthlyUsage: data.data || 0,
        })
        localStorage.setItem('count-gps-monthly-usage', data.data || 0)
      })
  }

  fetchSafetyNotificationSummary = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/safety-dashboard-notification/summary`,
        { vehicle_visibility: this.props.profile.vehicle_visibility },
        {
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
        },
      )

      if (res.data.status === 200) {
        this.setState({
          safetyNotiData: res.data.data.summary,
          safetyNotiEvents: res.data.data.events,
          safetyUnreadCount: res.data.data.unread_count,
          safetyUnreadByType: res.data.data.unread_by_type || null,
        })
      }
    } catch (error) {
      console.error('fetchSafetyNotificationSummary error:', error)
    }
  }

  markSafetyNotificationSeen = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/safety-dashboard-notification/mark-seen`,
        {},
        {
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
        },
      )
      this.setState({ safetyUnreadCount: 0, safetyUnreadByType: null })
    } catch (error) {
      console.error('markSafetyNotificationSeen error:', error)
    }
  }

  markSafetyNotificationSeenByType = eventType => {
    const prev =
      this.state.safetyUnreadByType || this.state.safetyNotiData || {}
    const cleared = prev[eventType] || 0
    if (cleared > 0) {
      this.setState({
        safetyUnreadByType: { ...prev, [eventType]: 0 },
        safetyUnreadCount: Math.max(0, this.state.safetyUnreadCount - cleared),
      })
    }

    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/safety-dashboard-notification/mark-seen`,
        { event_type: eventType },
        {
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
        },
      )
      .catch(error => {
        console.error('markSafetyNotificationSeenByType error:', error)
      })
  }

  fetchSafetyEventsByType = async (eventType, page = 1) => {
    this.setState(prev => ({
      safetyDetailLoading: { ...prev.safetyDetailLoading, [eventType]: true },
    }))
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/safety-dashboard-notification/events-by-type`,
        {
          event_type: eventType,
          page,
          per_page: 10,
          vehicle_visibility: this.props.profile.vehicle_visibility,
        },
        {
          headers: {
            Authorization: `Bearer ${this.props.accessToken}`,
          },
        },
      )

      if (res.data.status === 200) {
        const { events, has_more } = res.data.data
        this.setState(prev => ({
          safetyDetailEvents: {
            ...prev.safetyDetailEvents,
            [eventType]:
              page === 1
                ? events
                : [...(prev.safetyDetailEvents[eventType] || []), ...events],
          },
          safetyDetailHasMore: {
            ...prev.safetyDetailHasMore,
            [eventType]: has_more,
          },
          safetyDetailPage: {
            ...prev.safetyDetailPage,
            [eventType]: page,
          },
          safetyDetailLoading: {
            ...prev.safetyDetailLoading,
            [eventType]: false,
          },
        }))

        // Mark seen AFTER events loaded (page 1 only) to avoid race condition
        if (page === 1) {
          this.markSafetyNotificationSeenByType(eventType)
        }
      }
    } catch (error) {
      console.error('fetchSafetyEventsByType error:', error)
      this.setState(prev => ({
        safetyDetailLoading: {
          ...prev.safetyDetailLoading,
          [eventType]: false,
        },
      }))
    }
  }

  componentDidMount() {
    if (localStorage.length === 1) {
      window.location.reload()
    }

    let self = this
    let { tokenExp } = this.props
    let timeNow = Date.now()

    this.fetchData()
    this.fetchCountAppoveRequestToUseVehicle()
    this.fetchCountGPSServiceRequestsInstall()
    this.fetchCountGPSServiceRequestsRepair()
    this.fetchCountGPSServiceRequestsUninstall()
    this.fetchCountGpsMonthlyUsage()
    this.fetchSafetyNotificationSummary()

    this.safetyNotiInterval = setInterval(() => {
      this.fetchSafetyNotificationSummary()
    }, 300000)

    this.handleSafetyEventReceived = () => {
      this.setState(prev => ({
        safetyUnreadCount: prev.safetyUnreadCount + 1,
      }))
    }
    window.addEventListener(
      'safety-event-received',
      this.handleSafetyEventReceived,
    )

    if (
      typeof tokenExp === 'undefined' ||
      tokenExp == null ||
      tokenExp === ''
    ) {
      setTimeout(function() {
        self.modal(
          <LangContext.Consumer>
            {i18n => i18n.n.notification}
          </LangContext.Consumer>,
          <LangContext.Consumer>
            {i18n => i18n.t.tokenExpired}
          </LangContext.Consumer>,
        )
      }, 500)
    } else if (Math.floor(timeNow / 1000) < tokenExp) {
      let diffTime = (tokenExp - Math.floor(timeNow / 1000)) * 1000
      this.tokenExpTimeout = setTimeout(
        () =>
          self.modal(
            <LangContext.Consumer>
              {i18n => i18n.n.notification}
            </LangContext.Consumer>,
            <LangContext.Consumer>
              {i18n => i18n.t.tokenExpired}
            </LangContext.Consumer>,
          ),
        diffTime,
      )
    }

    if (typeof this.props.profile.id != 'undefined')
      this.props.loadFavoriteMenu({
        userId: this.props.profile.id,
        accessToken: this.props.accessToken,
        loading: false,
      })

    const savedLang = localStorage.getItem('lang') || 'th'
    this.setState({ inputLng: savedLang === 'en' ? 'us' : 'th' })
  }

  componentWillUnmount() {
    clearInterval(this.tokenExpTimeout)
    clearInterval(this.safetyNotiInterval)
    window.removeEventListener(
      'safety-event-received',
      this.handleSafetyEventReceived,
    )
  }

  checkSelectLang = inputLng => {
    this.props.changeLang(inputLng)
    if (inputLng === 'en') {
      this.setState({ inputLng: 'us' })
    } else {
      this.setState({ inputLng: 'th' })
    }
  }

  modal = (title, content) => {
    this.onRemoveCredentials()
    Modal.warning({
      title: title,
      okText: 'Ok',
      okType: 'default',
      content: content,
    })
  }

  handleVisibleChange = visibleNotification => {
    this.setState({ visibleNotification })
  }

  handleUnVisibleChange = () => {
    this.setState({ visibleNotification: false })
  }

  // เมนูบนหัว — desktop เป็นแถบแนวนอน, มือถือเป็นรายการแนวตั้งใน Drawer
  // ใช้ JSX ชุดเดียวกันทั้งสองโหมด จะได้ไม่ต้องดูแลเมนูสองชุด
  renderTopMenu = ctx => {
    const {
      i18n,
      favoriteMenu,
      inputLng,
      displayUsername,
      displayFullName,
      fullName,
      done,
      profile,
    } = ctx

    return (
      <Menu
        theme="light"
        mode="horizontal"
        style={{ height: '46px' }}
        align="right"
      >
        {/* RMC OPERATION DASHBOARD */}
        <SubMenu
          className="ant-top-menu"
          title={
            <Tooltip
              placement="bottom"
              title="RMC Operation Dashboard"
              arrowPointAtCenter
            >
              <Icon
                style={{ fontSize: '17px' }}
                type="area-chart"
                onClick={() =>
                  window.open(
                    'https://dev-rop.cipcloud.net/proactive/',
                    '_blank',
                  )
                }
              />
            </Tooltip>
          }
        />

        {/* MANUAL */}
        <SubMenu
          className="ant-top-menu"
          title={
            <Tooltip
              placement="bottom"
              title={i18n.m.manual}
              arrowPointAtCenter
            >
              <Icon
                style={{ fontSize: '17px' }}
                type="read"
                onClick={() =>
                  window.open(
                    'https://scgo365.sharepoint.com/sites/rmcexcellence/fleetlinkmanual',
                    '_blank',
                  )
                }
              />
            </Tooltip>
          }
        />
        {/* Safety Dashboard Notification */}
        <SubMenu
          className="ant-top-menu"
          title={
            <Popover
              content={
                <SafetyNotificationPopover
                  data={this.state.safetyNotiData}
                  events={this.state.safetyNotiEvents}
                  unreadByType={this.state.safetyUnreadByType}
                  detailEvents={this.state.safetyDetailEvents}
                  detailHasMore={this.state.safetyDetailHasMore}
                  detailPage={this.state.safetyDetailPage}
                  detailLoading={this.state.safetyDetailLoading}
                  onLoadMore={this.fetchSafetyEventsByType}
                  visible={this.state.safetyNotiVisible}
                  onClose={() =>
                    this.setState({ safetyNotiVisible: false })
                  }
                />
              }
              trigger="click"
              visible={this.state.safetyNotiVisible}
              onVisibleChange={visible => {
                this.setState({ safetyNotiVisible: visible })
                if (visible) {
                  Object.keys(
                    this.state.safetyDetailEvents,
                  ).forEach(key =>
                    this.fetchSafetyEventsByType(key, 1),
                  )
                }
              }}
              placement="bottomRight"
            >
              <Badge
                count={this.state.safetyUnreadCount}
                overflowCount={99}
              >
                <Icon
                  type="bell"
                  style={{ color: '#1890FF', fontSize: '16px' }}
                />
              </Badge>
            </Popover>
          }
          onTitleClick={() => {
            this.setState({ safetyNotiVisible: true })
          }}
        />

        {/* FAVORITE */}
        <SubMenu
          className="ant-top-menu"
          title={
            <span>
              <NoticeIcon
                bell={
                  <Icon
                    type="star"
                    style={{ color: '#1890FF', fontSize: '16px' }}
                  />
                }
              >
                <NoticeIcon.Tab
                  showClear={false}
                  list={this.getNoticeData(i18n, favoriteMenu)}
                  title={i18n.f.favoriteMenu}
                  emptyText={i18n.n.noData}
                  emptyImage="https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg"
                />
              </NoticeIcon>
            </span>
          }
        />

        {/* LANGUAGE */}
        <SubMenu
          className="ant-top-menu"
          title={
            <span>
              <ReactCountryFlag
                styleProps={{
                  margin: '0px 15px 5px 0px',
                  width: '20px',
                  height: '20px',
                }}
                code={inputLng}
                svg
              />
              <Icon
                type="caret-down"
                style={{ color: '#1890FF' }}
              />
            </span>
          }
        >
          <MenuItemGroup title={i18n.c.changeLanguage}>
            <Menu.Item key="en" selected={true}>
              <span
                className="nav-text"
                onClick={() => this.checkSelectLang('en')}
              >
                <ReactCountryFlag
                  styleProps={{
                    margin: '0px 15px 5px 0px',
                    width: '20px',
                    height: '20px',
                  }}
                  code="us"
                  svg
                />
                English
              </span>
            </Menu.Item>
            <Menu.Item key="th" selected={true}>
              <span
                className="nav-text"
                onClick={() => this.checkSelectLang('th')}
              >
                <ReactCountryFlag
                  styleProps={{
                    margin: '0px 15px 5px 0px',
                    width: '20px',
                    height: '20px',
                  }}
                  code="th"
                  svg
                />
                ไทย
              </span>
            </Menu.Item>
          </MenuItemGroup>
        </SubMenu>

        {/* PROFILE */}
        <SubMenu
          style={{ width: '220px' }}
          className="ant-top-menu"
          title={
            <Row style={{ height: '46px' }}>
              <Col xs={1} sm={1} md={1} lg={2} xl={2}>
                <Icon
                  type="user"
                  style={{ fontSize: '16px', color: '#1890FF' }}
                />
              </Col>
              <Col
                xs={0}
                sm={0}
                md={23}
                lg={20}
                xl={20}
                style={{ height: '46px' }}
              >
                <Tooltip
                  placement="bottom"
                  title={fullName}
                  arrowPointAtCenter
                >
                  <Row
                    style={{
                      margin: '-11px 0px 0px 20px',
                      color: '#1890FF',
                    }}
                  >
                    {displayUsername}
                  </Row>
                  <Row
                    style={{
                      margin: '-27px 0px 0px 20px',
                      color: '#1890FF',
                    }}
                  >
                    {displayFullName}
                  </Row>
                </Tooltip>
              </Col>
            </Row>
          }
        >
          <MenuItemGroup
            title={<span className="semi-bold-16">Account</span>}
          >
            <Menu.Item
              key="setting:1"
              style={{ paddingLeft: '14px' }}
            >
              <Icon type="home" style={{ color: 'black' }} />
              <span style={{ fontSize: '14px', color: 'black' }}>
                {i18n.h.home}
              </span>
              <Link to="/" />
            </Menu.Item>
            <Menu.Item
              key="setting:2"
              style={{ paddingLeft: '14px' }}
            >
              <Icon type="user" style={{ color: 'black' }} />
              <span style={{ fontSize: '14px', color: 'black' }}>
                {i18n.p.profile}
              </span>

              <Link to="/profile" />
            </Menu.Item>
            {done ? (
              <Menu.Item
                key="menu:1"
                onClick={this.onRemoveCredentials}
                style={{ paddingLeft: '14px' }}
              >
                <Icon type="logout" style={{ color: 'black' }} />
                <span style={{ fontSize: '14px', color: 'black' }}>
                  {i18n.l.logout}
                </span>

                <Link to="/" />
              </Menu.Item>
            ) : (
              <Menu.Item
                key="menu:1"
                style={{ paddingLeft: '14px' }}
              >
                <span style={{ fontSize: '14px' }}>
                  {i18n.l.login}
                </span>

                <Link to="/" />
              </Menu.Item>
            )}
          </MenuItemGroup>
        </SubMenu>
      </Menu>
    )
  }

  // เมนู header สำหรับจอเล็ก — แบนราบ ไม่มีเมนูซ้อนเมนู คั่นกลุ่มด้วย divider
  // ซ่อนแจ้งเตือนกับเมนูโปรด เพราะทั้งคู่เป็น popover ที่ไม่เหมาะกับจอแคบ
  renderMobileMenu = ctx => {
    const { i18n, done } = ctx
    const close = () => this.setState({ topMenuVisible: false })
    const isEnglish = this.state.inputLng === 'us'

    // ปุ่มภาษาแถวเดียว — ตั้งครั้งเดียวแล้วแทบไม่แตะอีก ไม่ควรกินพื้นที่ 3 แถว
    const langPill = (code, label, active) => (
      <span
        onClick={() => {
          close()
          this.checkSelectLang(code)
        }}
        style={{
          padding: '1px 8px',
          borderRadius: '4px',
          background: active ? '#e6f7ff' : 'transparent',
          color: active ? '#1890ff' : 'rgba(0, 0, 0, 0.45)',
          fontWeight: active ? 600 : 400,
        }}
      >
        {label}
      </span>
    )

    return (
      <Menu selectable={false}>
        <Menu.Item key="home" onClick={close}>
          <Link to="/">
            <Icon type="home" style={{ marginRight: 10 }} />
            {i18n.h.home}
          </Link>
        </Menu.Item>

        <Menu.Item key="profile" onClick={close}>
          <Link to="/profile">
            <Icon type="user" style={{ marginRight: 10 }} />
            {i18n.p.profile}
          </Link>
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item
          key="rmc"
          onClick={() => {
            close()
            window.open('https://dev-rop.cipcloud.net/proactive/', '_blank')
          }}
        >
          <Icon type="area-chart" style={{ marginRight: 10 }} />
          RMC Operation Dashboard
        </Menu.Item>

        <Menu.Item
          key="manual"
          onClick={() => {
            close()
            window.open(
              'https://scgo365.sharepoint.com/sites/rmcexcellence/fleetlinkmanual',
              '_blank',
            )
          }}
        >
          <Icon type="read" style={{ marginRight: 10 }} />
          {i18n.m.manual}
        </Menu.Item>

        <Menu.Divider />

        <Menu.Item key="language">
          <Icon type="global" style={{ marginRight: 10 }} />
          {i18n.l.language}
          <span style={{ float: 'right' }}>
            {langPill('th', 'ไทย', !isEnglish)}
            {langPill('en', 'EN', isEnglish)}
          </span>
        </Menu.Item>

        <Menu.Divider />

        {done ? (
          <Menu.Item
            key="logout"
            onClick={() => {
              close()
              this.onRemoveCredentials()
            }}
          >
            <Link to="/">
              <Icon type="poweroff" style={{ marginRight: 10 }} />
              {i18n.l.logout}
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item key="login" onClick={close}>
            <Link to="/">
              <Icon type="login" style={{ marginRight: 10 }} />
              {i18n.l.login}
            </Link>
          </Menu.Item>
        )}
      </Menu>
    )
  }

  render() {
    localStorage.length === 1 && window.location.reload()
    const { done, favoriteMenu } = this.props
    const {
      inputLng,
      collapsed,
      countAppoveRequestToUseVehicle,
      countGPSServiceRequestsInstall,
      countGPSServiceRequestsRepair,
    } = this.state

    const profile = JSON.parse(localStorage.getItem('profile')) || {}

    const firstName = profile.firstname || ''
    const lastName = profile.lastname || ''
    const username = profile.username || ''

    const truncate = (text, max = 20) =>
      text.length > max ? text.slice(0, max - 1) + '...' : text

    const displayUsername = truncate(username)

    const fullName = (firstName + ' ' + lastName).trim()
    const displayFullName = truncate(fullName)

    return (
      <LangContext.Consumer>
        {i18n => (
          <>
            <StyledHearder>
              {AUDIOS.map(audio => (
                <audio key={audio.name} id={`audio-${audio.name}`}>
                  <source src={`/audio/${audio.path}.mp3`} type="audio/mpeg" />
                </audio>
              ))}

              <Row
                type="flex"
                justify="space-between"
                align="middle"
                style={{
                  lineHeight: '20px',
                  padding: '0px 0px 0px 0px',
                  margin: '0px 0px 0px 0px',
                }}
              >
                {/* MENU TRIGGER */}
                <Col xs={4} sm={3} md={1} lg={1} xl={1}>
                  <Icon
                    style={{
                      margin: '3px 0px 0px 15px',
                      color: '#1890FF',
                      fontSize: '24px',
                    }}
                    className="trigger"
                    type="menu"
                    onClick={() => {
                      this.fetchCountAppoveRequestToUseVehicle()
                      this.fetchCountGPSServiceRequestsInstall()
                      this.fetchCountGPSServiceRequestsRepair()
                      this.toggle()
                    }}
                  />
                </Col>

                {/* LOGO */}
                <Col xs={7} sm={5} md={4} lg={4} xl={4}>
                  <Link
                    to="/"
                    onClick={e => {
                      // Some overlays/menus can swallow Link navigation; force navigation to home.
                      e.preventDefault()
                      try {
                        this.props.history.push('/')
                      } catch (err) {
                        window.location.assign('/')
                      }
                    }}
                  >
                    <img
                      style={{
                        width: '85px',
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                      }}
                      src="/img/2.png"
                      alt="logo"
                    />
                  </Link>
                </Col>

                {/* เมนูบน — desktop เท่านั้น */}
                <Col
                  xs={0}
                  sm={0}
                  md={19}
                  lg={19}
                  xl={19}
                  align="right"
                >
                  {this.renderTopMenu({
                    i18n,
                    favoriteMenu,
                    inputLng,
                    displayUsername,
                    displayFullName,
                    fullName,
                    done,
                    profile,
                  })}
                </Col>

                {/* มือถือ — ยุบเป็นปุ่มเดียว กดแล้วเลือกจากรายการ */}
                <Col xs={13} sm={16} md={0} align="right">
                  <Dropdown
                    overlay={this.renderMobileMenu({ i18n, done })}
                    trigger={['click']}
                    placement="bottomRight"
                    visible={this.state.topMenuVisible}
                    onVisibleChange={v =>
                      this.setState({ topMenuVisible: v })
                    }
                  >
                    <Icon
                      type="ellipsis"
                      style={{
                        color: '#1890FF',
                        fontSize: '24px',
                        margin: '4px 12px 0px 0px',
                      }}
                    />
                  </Dropdown>
                </Col>
              </Row>
            </StyledHearder>

            {/* DRAWER */}
            <Drawer
              title={<h3 className="text-header-side-bar">MENU</h3>}
              id="drawer"
              placement="left"
              onClose={this.toggle}
              visible={!collapsed}
              style={{ position: 'absolute' }}
              bodyStyle={{ padding: '0px', border: '0px' }}
              width={322}
              height={max}
            >
              <SliderBar
                countAppoveRequestToUseVehicle={countAppoveRequestToUseVehicle}
                countGPSServiceRequestsInstall={countGPSServiceRequestsInstall}
                countGPSServiceRequestsRepair={countGPSServiceRequestsRepair}
              />
            </Drawer>
          </>
        )}
      </LangContext.Consumer>
    )
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp, favoriteMenu },
}) => ({
  accessToken,
  done,
  profile,
  tokenExp,
  favoriteMenu,
})

const mapDispatchToProps = {
  loadFavoriteMenu: authActions.loadFavoriteMenu.request,
  removeCredentials: authActions.removeCredentials,
  removeUIState: removeUIState,
  deleteFavoriteMenu: authActions.deleteFavoriteMenu.request,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
